import { useState } from 'react';
import ViewResourceCard from './ViewResourceCard';
import EditResourceCard from './EditResourceCard';
import { GroupRosterItem } from 'hooks/incident/useRoster';

type Incident = {
  id: string;
  name: string;
};

export type User = {
  userName: string;
  userGuid: string;
  emailAddress: string;
};

export type ResourceRow = {
  id: string;
  name: string;
  kind: string;
  type: string;
  assetStatus?: string;
  assetStatusTimestamp?: string;
  quantity?: number;
  incident?: Incident | null;
  assignees?: User[];
  owning_organization?: string;
  description?: string;
  address?: string;
  datetimeOrdered?: string;
  datetimeOrderedOffset?: number;
  pointOfContact?: User;
  isTemplate?: boolean;
  resource_set_id?: string;
  incident_details?: Incident[];
  unit?: string;
  persons_on_board?: any; //This only has a value if assigned to an Incident; else value is null and the user sees a greyed-out toggle.
  hull_tail_number?: string;
  status?: string;
  aor?: string;
  inRequest?: boolean;
  opcon?: string;
  tacon?: string;
  symbology?: string;
  latitude?: number;
  longitude?: number;
  eta?: string;
  etaTimezoneOffset?: number;
  notes?: string;
  is_external_resource?: boolean;
  external_resource_info_last_updated?: string | null;
  external_resource_info_out_of_date?: boolean;
};

interface ResourceCardProps {
  row: ResourceRow;
  groupMembers: GroupRosterItem[];
  setShowCheckInDrawer: (show: boolean) => void;
  setSelectedResource?: (resource: string | null) => void;
  setShowCheckOutDrawer?: (show: boolean) => void;
  viewOnly?: boolean;
  compact?: boolean;
}

const ResourceTabCard = ({
  row,
  groupMembers,
  setShowCheckInDrawer,
  setShowCheckOutDrawer,
  setSelectedResource,
  viewOnly,
  compact,
}: ResourceCardProps) => {
  const [expanded, setExpanded] = useState(false);
  const [isEditing, setIsEditing] = useState(false);

  return (
    <div className={'resource-border'}>
      {isEditing ? (
        <EditResourceCard
          row={row}
          setIsEditing={setIsEditing}
          groupMembers={groupMembers}
          compact={compact}
        />
      ) : (
        <ViewResourceCard
          row={row}
          expanded={expanded}
          setExpanded={setExpanded}
          setIsEditing={setIsEditing}
          setShowCheckInDrawer={setShowCheckInDrawer}
          setSelectedResource={setSelectedResource}
          setShowCheckOutDrawer={setShowCheckOutDrawer}
          viewOnly={viewOnly}
          compact={compact}
        />
      )}
    </div>
  );
};

export default ResourceTabCard;
